import React from 'react';

const DefaultAdSettingBox = () => {
  return (
    <div className="box_setting">
      <form>
        <fieldset>
          <legend className="screen_out">광고 노출설정</legend>
          <ul className="list_setting_ad">
            <li>
              <div className="box_edit">
                <strong className="tit_g">전체 자동광고<span className="ico_blog"/></strong>
                <dl>
                  <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                  <dd>자동 광고</dd>
                </dl>
                <dl>
                  <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                  <dd>자동 광고</dd>
                </dl>
                <a className="btn_post">수정</a>
              </div>
              <div className="check_blog">
                <input type="checkbox" id="inptCheck0" className="inp_check"/>
                <label htmlFor="inptCheck0" className="ico_blog ico_checkbox_type1">선택 됨</label>
              </div>
            </li>
            <li>
              <div className="box_edit">
                <strong className="tit_g">본문 상단</strong>
                <dl>
                  <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                  <dd> 728 x 90</dd>
                </dl>
                <dl>
                  <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                  <dd> 320 x 250</dd>
                </dl>
                <a className="btn_post">수정</a>
              </div>
              <div className="check_blog">
                <input type="checkbox" id="inptCheck1" className="inp_check"/>
                <label htmlFor="inptCheck1" className="ico_blog ico_checkbox_type1">선택 됨</label>
              </div>
            </li>
            <li>
              <div className="box_edit">
                <strong className="tit_g">본문 하단</strong>
                <dl>
                  <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                  <dd> 320 x 250</dd>
                </dl>
                <dl>
                  <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                  <dd> 250 x 250</dd>
                </dl>
                <a className="btn_post">수정</a>
              </div>
              <div className="check_blog">
                <input type="checkbox" id="inptCheck2" className="inp_check"/>
                <label htmlFor="inptCheck2" className="ico_blog ico_checkbox_type1">선택 됨</label>
              </div>
            </li>
            <li>
              <div className="box_edit">
                <strong className="tit_g">사이드바</strong>
                <dl>
                  <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                  <dd>사용 안함</dd>
                </dl>
                <dl>
                  <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                  <dd>사용 안함</dd>
                </dl>
                <a className="btn_post">수정</a>
              </div>
              <div className="check_blog">
                <input type="checkbox" id="inptCheck3" className="inp_check"/>
                <label htmlFor="inptCheck3" className="ico_blog ico_checkbox_type1">선택 됨</label>
              </div>
            </li>
            <li>
              <div className="box_edit">
                <strong className="tit_g">목록 상단</strong>
                <dl>
                  <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                  <dd> 728 x 90</dd>
                </dl>
                <dl>
                  <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                  <dd> 468 x 60</dd>
                </dl>
                <a className="btn_post">수정</a>
              </div>
              <div className="check_blog">
                <input type="checkbox" id="inptCheck4" className="inp_check"/>
                <label htmlFor="inptCheck4" className="ico_blog ico_checkbox_type1">선택 됨</label>
              </div>
            </li>
            <li>
              <div className="box_edit">
                <strong className="tit_g">목록 하단</strong>
                <dl>
                  <dt><span className="ico_blog ico_pc_type1">PC</span></dt>
                  <dd>사용 안함</dd>
                </dl>
                <dl>
                  <dt><span className="ico_blog ico_mobile_type1">모바일</span></dt>
                  <dd> 468 x 60</dd>
                </dl>
                <a className="btn_post">수정</a>
              </div>
              <div className="check_blog">
                <input type="checkbox" id="inptCheck5" className="inp_check"/>
                <label htmlFor="inptCheck5" className="ico_blog ico_checkbox_type1">선택 됨</label>
              </div>
            </li>
          </ul>
        </fieldset>
      </form>
    </div>
  )
};

export default DefaultAdSettingBox;